import Api from "@/api/index";
// import store from "@/store";
// import alerts from "@/components/alerts/alert";
// import router from "@/router";

const rules = {
  namespaced: true,
  state: {
    datas: {},
    queryParam: {},
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
  },
  mutations: {
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
  },
  actions: {
    async paginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate("rules/page", payload).then(({ data }) => {
        commit("SET_DATAS", data);
        commit("SET_LOADING", false);
      });
    },
  },
};

export default rules;
